import styled from 'styled-components';

export const TooltipIconContainer = styled.span`
  position: relative;
  height: max-content;
  width: max-content;

  .icon {
    line-height: 0;
  }
  .tooltip-wrapper {
    .tooltip {
      transform: translateY(-50%);
    }
  }
`;
